import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { MessageService } from '../_services/message.service';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MustMatch } from '../_helpers/MustMatch';
import * as CryptoJS from 'crypto-js';
import { ProductoService } from '../_services/producto.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  data = '';
  username = '';
  oldpassword = '';
  resetPassword: FormGroup;

  urlBackLogin = '';
  idAplicacion: string;
  session: string;
  redirectUrl: string;
  filtroAdicional: string;

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private location: Location,
    private messageService: MessageService,
    private fb: FormBuilder,
    private productoService: ProductoService) {

    this.route.queryParams.subscribe(params => {
      this.idAplicacion = this.route.snapshot.paramMap.get('idAplicacion');
      this.session = this.route.snapshot.paramMap.get('session');
      this.redirectUrl = params.redirectUrl == undefined ? '' : params.redirectUrl;
      this.filtroAdicional = params.filtroAdicional == undefined ? '' : params.filtroAdicional;
      const paramUsuario = this.route.snapshot.paramMap.get('usuario').split(',').join('/');
      this.username = CryptoJS.AES.decrypt(paramUsuario, environment.encodeKey).toString(CryptoJS.enc.Utf8).split('|')[0];
      this.productoService.setCurrentApp(this.idAplicacion);
    });
  }

  ngOnInit(): void {
    const maxLength = Validators.minLength(6);

    this.resetPassword = this.fb.group({
      password: ['', [Validators.required, maxLength]],
      confirmpassword: ['', [Validators.required, maxLength]]
    }, {
      validator: [
        MustMatch('password', 'confirmpassword')
      ]
    });
  }

  onResetPassword() {
    this.authenticationService.resetPassword(this.username, this.resetPassword.value.password, this.session, this.idAplicacion).subscribe(data => {
      this.messageService.sendMessage('Modificación de Contraseña', 'Su contraseña ha sido modificada exitosamente.', 0, 'info');
      this.authenticationService.redirectUsuarioLogeado(data, this.redirectUrl);
    }, error => {
      switch (error.status) {
        case 401:
        case 409:
          this.messageService.sendMessage('<h2>Error</h2>', error.error, 0, 'danger');
          break;
        default:
          this.messageService.sendErrorMessage();
          break;
      }
    });
  }

  clickBackConfig() {
    this.location.back();
  }

  // Es la segunda vez que encuentro esto, debería estar en un servicio
  login(username: string, password: string) {
    //   this.authenticationService.login(username, password).subscribe(data => {

    //     if (data.mensajeLogin == ResponseUser.OK) {
    //       //Todo: Ir a Producto
    //     }

    //     if (data.mensajeLogin == ResponseUser.UNCONFIRMED || data.mensajeLogin == ResponseUser.CHANGEPASSWORD) {
    //       let encripted = CryptoJS.AES.encrypt(username + '|' + password, environment.encodeKey).toString().split('/').join();
    //       if (data.mensajeLogin == ResponseUser.UNCONFIRMED) {
    //         this.router.navigate(['/verification/' + encripted]);
    //       }
    //       else {
    //         this.router.navigate(['/resetpassword/' + encripted]);
    //       }
    //     }
    //   });
  }
}
